/**
 * Academic year runs June–April (Telangana SCERT plan).
 * May is treated as new-year preparation, so it belongs to the upcoming year.
 * e.g. May 2026 → "2026-2027"
 *      October 2025 → "2025-2026"
 *      February 2026 → "2025-2026"
 */
export function getCurrentAcademicYear() {
  const now = new Date();
  const month = now.getMonth() + 1; // 1–12
  const year = now.getFullYear();
  // Month >= 5 (May+): new year preparation → year to year+1
  // Month < 5 (Jan–Apr): still in previous year → (year-1) to year
  if (month >= 5) {
    return `${year}-${year + 1}`;
  }
  return `${year - 1}-${year}`;
}

/**
 * Returns a list of academic years: current + 2 previous.
 */
export function getAcademicYearOptions() {
  const current = getCurrentAcademicYear();
  const startYear = parseInt(current.split('-')[0], 10);
  return [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];
}
